import styled from "styled-components";
import media from "../../styles/media";
import {
  flexHelpers,
  marginHelpers,
  paddingHelpers,
} from "../../styles/positioning";

const ButtonGroup = styled.div`
  ${paddingHelpers} ${marginHelpers} width: 100%;

  span,
  button,
  a {
    margin-bottom: ${({ theme }) => theme.padding.small};
    width: 100%;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ${media.sm`
    flex-direction: row;
    align-items: flex-start;

    span, button, a {
      margin-right: ${({ theme }) => theme.padding.small};
      margin-bottom: 0;
      width: auto;

      &:last-child {
        margin-right: 0;
      }
    }
  `} ${flexHelpers};
`;

ButtonGroup.displayName = "ButtonGroup";

// eslint-disable-next-line
export default ButtonGroup;
